const backToTop = document.querySelector("#back-to-top");
const header = document.querySelector("#header");
const pageHasBanner = header.getAttribute("data-hasbanner") === "true";

AOS.init({ disable: "mobile" });

backToTop?.addEventListener("click", () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
});

pageHasBanner &&
  window.addEventListener("scroll", () => {
    window.pageYOffset > 300
      ? header?.setAttribute("data-onscroll", "true")
      : header?.setAttribute("data-onscroll", "false");
  });
